$(document).ready(() => {
    $('form.form-loader').on('submit', (e) => {
        $('.loader-wrapper button').attr('disabled', true);
        $('.loader-wrapper img.loader').addClass('visible');
    });
});
